import React from 'react';

import * as Yup from 'yup';
import { useMutation } from '@tanstack/react-query';

import Modal from '../../../components/Modal';
import CrudForm from '../../../components/Form/CrudForm';

import { USER_ROLES } from '../../../constants/formOptions';
import UserService from '../../../services/UserService';
import { useUiStore } from '../../../store';

const fields = [
  {
    label: 'Name',
    name: 'name',
    type: 'text',
    placeholder: 'Enter name',
    validation: Yup.string().required('This field is required'),
    fullWidth: true,
  },
  {
    label: 'Email',
    name: 'email',
    type: 'text',
    placeholder: 'Enter email address',
    validation: Yup.string()
      .email('Invalid email format')
      .required('This field is required'),
  },
  {
    label: 'User Role',
    name: 'role',
    type: 'select',
    placeholder: 'Select user role',
    validation: Yup.string().required('This field is required'),
    options: USER_ROLES,
  },
];

export default function InviteUserModal({ isVisible, hideModal, refetch }) {
  const notify = useUiStore((state) => state.notify);
  const notifyApiError = useUiStore((state) => state.notifyApiError);

  const { mutate: createUser, isPending } = useMutation({
    mutationFn: (formValues) => UserService.createUser(formValues),
    onSuccess: () => {
      notify({ type: 'success', message: 'User invited successfully' });
      refetch();
      hideModal();
    },
    onError: (error) => {
      console.log(error);
      notifyApiError(error);
    },
  });

  return (
    <Modal isVisible={isVisible} hideModal={hideModal} title="Invite User">
      <div className="md:min-w-[600px] min-w-auto pt-4">
        <CrudForm
          fields={fields}
          submitButtonLabel="Invite"
          createHandler={createUser}
          isPending={isPending}
        />
      </div>
    </Modal>
  );
}
